import scribdAuthorize from '../scribd/scribd_oauth.js';

$(document).ready(function() {
  $('a.fileupload.loggedout').on('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    amplitude.getInstance().logEvent('upload_flow_click_select_files', { 'view': 'loggedout' });
    scribdAuthorize({ from_source: window.location.pathname });
  });

  // Prevent browser's default action for drag and drop
  // This prevents most browsers from opening the file is not dropped in the drop area.
  $(document).bind('drop dragover', function (e) {
    e.preventDefault();
  });

  // Enable the drop event only for file type
  var isFileDropped = function(e) {
    try {
      if (e.originalEvent.dataTransfer.items[0].kind !== 'file'){
        return true;
      }
    } catch (e) { return false; }
  };

  $(document).bind('drop', function (e) {
    if (isFileDropped(e)){
      return;
    }
    amplitude.getInstance().logEvent('upload_flow_file_drop', { 'view': 'loggedout' });
    $('.cta-upload .j-upload_button_placeholder, .fileupload').click();
  });


  // Handle file drag events
  $(document).bind('dragover', function (e) {
    if (isFileDropped(e)){
      return;
    }
    var dropZone = $('#drag-area'),
        timeout = window.dropZoneTimeout;
    if (!timeout) {
      dropZone.show().removeClass("hide");
    } else {
      clearTimeout(timeout);
    }
    window.dropZoneTimeout = setTimeout(function () {
      window.dropZoneTimeout = null;
      dropZone.hide().addClass("hide");
    }, 100);

  });
});
